import { render, staticRenderFns } from "./choiceSpace.vue?vue&type=template&id=a1524602"
import script from "./choiceSpace.vue?vue&type=script&lang=js"
export * from "./choiceSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports